export enum USER_ROLE {
    ADMIN,
    USER,
  }

  export enum MESSAGE_TYPE {
    SUCCESS = 1,
    WARNING = 2,
    ERROR = 3,
  }